import type { HighFrequency_AddOnRestriction } from '#api/shared/@types/generated/backend/graphql-schema-types'

type AddOnRestrictionHandler = (
  restriction: HighFrequency_AddOnRestriction,
  payload: { selectedNumbers: number[] },
) => boolean | undefined

const HANDLERS: AddOnRestrictionHandler[] = [
  (restriction, { selectedNumbers }) => {
    if (!isHighFrequencyAddOnExcludeSelectedNumbers(restriction)) return

    const disabledForNumberOfSpots = restriction.selected
    const numberOfSpots = selectedNumbers.length

    return disabledForNumberOfSpots.includes(numberOfSpots)
  },
]

export const isAddOnDisabled = (
  restriction: HighFrequency_AddOnRestriction,
  payload: { selectedNumbers: number[] },
) => {
  for (const handler of HANDLERS) {
    const result = handler(restriction, payload)
    if (result) return true
  }

  return false
}
